<template>
  <div class="column_center_center code_card">
    <div class="buttons_container" :class="{ notLogin: !isLogin }">
      <tabs :buttonItems="buttons" :currentTabIndex="currentTabIndex" @setCurrentTab="setCurrentTab"></tabs>
    </div>

    <div class="row_center_center code_container" v-if="currentTabIndex == 0 && isLogin">
      <QRCode :value="memberQrCode" :size="100" level="H" renderAs="svg" />
    </div>

    <div class="row_center_center code_container" v-show="invoiceCarrierState && currentTabIndex == 1 && isLogin">

      <svg id="barcode"></svg>

    </div>

    <div class="row_center_center code_container" v-if="!invoiceCarrierState && isLogin && currentTabIndex == 1">

      <div class="row_center_center fake_barcode title">尚未設定手機載具</div>

    </div>

    <div class="row_center_center code_container" v-show="npoBanState && isLogin && currentTabIndex == 2">

      <svg id="npoBan"></svg>

    </div>

    <div class="row_center_center code_container" v-if="!npoBanState && isLogin && currentTabIndex == 2">

      <div class="row_center_center fake_barcode title">尚未設定愛心碼</div>

    </div>

    <loginCard v-if="!isLogin" @login="login"></loginCard>
  </div>
</template>
<script>
import JsBarcode from "jsbarcode";
import QRCode from "qrcode.vue";
import loginCard from "./loginCard.vue";
import tabs from "../../components/tabButton.vue";
import apiData from "@/services/apiData";
import {
		mapState,
		mapGetters
	} from 'vuex';
export default {
  props: {},
  components: {
    QRCode,
    loginCard,
    tabs,
  },
  data() {
    return {
      currentTabIndex: 0,
      buttons: [
        {
          name: "會員條碼",
        },
        {
          name: "發票載具",
        },
        {
          name: "愛心碼",
        },
      ],
    };
  },
  watch: {
    invoiceCarrierState(state) {
      if (state) {
        console.log('carrier', `${this.carrier}`)
        JsBarcode("#barcode", `${this.carrier}`, {
          format: "CODE39",
          displayValue: true,
          fontSize: 22,
          height: 40,
          width: 1.5,
          textMargin: 25,
          margin: 10,
          lineColor: "#343434",
        });
      }
    },
    npoBanState(state) {
      if (state) {
        console.log('npo ban', this.npoBan)
        JsBarcode("#npoBan", this.npoBan, {
          format: "CODE39",
          displayValue: true,
          fontSize: 22,
          height: 40,
          width: 1.5,
          textMargin: 25,
          margin: 10,
          lineColor: "#343434",
        });
      }
    },
    isLogin(val) {
      if (!val) {
        this.currentTabIndex = 0;
      }
    }
  },
  mounted() {
    this.$store.commit("basic/setInvoiceCarrierState", false);
    this.$store.commit("basic/setNpoBanState", false);
  },
  computed: {
    ...mapState('userData', {
      userInfo: 'userInfo',
    }),
    ...mapGetters('userData', {
      isLogin: 'isLogin',
      memberQrCode: 'memberQrCode',
      carrier: 'carrier',
      npoBan: 'npoBan',
    }),
    ...mapState('basic', {
      invoiceCarrierState: 'invoiceCarrierState',
      npoBanState: 'npoBanState',
      currentStore: 'currentStore',
    }),
  },
  methods: {
    login() {
      let data = new apiData();
      data.store = this.currentStore;
      this.$store.dispatch('line/login', data)
    },
    setCurrentTab(index) {
      //未登錄狀態 不可切換
      if (!this.isLogin) {
        return;
      }
      this.$store.commit("basic/setInvoiceCarrierState", false);
      this.$store.commit("basic/setNpoBanState", false);
      // 如果有載具 動態生成條碼
      if (index == 1 && this.carrier) {
        this.$store.commit("basic/setInvoiceCarrierState", true);
      }
      // 如果有愛心碼 動態生成條碼
      if (index == 2 && this.npoBan) {
        this.$store.commit("basic/setNpoBanState", true);
      }
      this.currentTabIndex = index;
    },
  },
};
</script>
<style lang="scss" scoped>
.code_card {
  margin: 0 auto;
}

.notLogin {
  opacity: 0.4;
}

.code_container {
  background-color: #fff;
  width: 90vw;
  height: 150px;
  border-radius: 6px;
  margin: 5px auto;
}

.buttons_container {
  display: flex;
  align-items: center;
  height: 60px;
  color: #999;
  width: 86vw;
  justify-content: space-around;
  margin-top: 5px;
  margin-bottom: 7px;
}

.bind_carrier_hint {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 400;
  width: 100%;
  height: 100px;
  margin-top: 10px;

  button {
    border: 2px solid #000;
    border-radius: 10px;
    margin-bottom: 18px;
    color: #000;
    border-radius: 8px;
    background-color: transparent;
    padding: 14px 43px;
    font-weight: 500;
    font-size: 14px;
  }

  .fake_barcode {
    width: 185px;
    height: 42px;
    background-color: transparent;
    margin: 0 auto;
    background-color: #fff;
  }

  ::placeholder {
    color: rgba(157, 157, 157, 1);
  }

  input {
    padding: 10px 14px;
    width: 240px;
    height: 25px;
    margin: 0 auto;
    text-align: left;
    font-size: 15px;
    font-weight: 400;
    border: none;
    background-color: rgba(238, 238, 238, 1);
    border-bottom: 1px solid rgba(197, 197, 197, 1);
    border-radius: 4px;
    text-transform: uppercase;
    color: #000;
  }
}

.edit_carrier {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #a2a2a2;
  width: 74vw;
  height: 0;
  margin: -8px -30px 0 0;

  img {
    margin-right: 5px;
  }
}

.popup_container {
  width: 750rpx;
  z-index: 999;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;

  .popup_cover {
    flex-grow: 1;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .popup_input {
    max-height: 118px;
    background-color: #fff;
    padding: 26.5px 0px;
    width: 375px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;

    p {
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 14px;
      margin-left: 30px;
      height: 20px;
    }

    ::placeholder {
      color: rgba(157, 157, 157, 1);
    }

    input {
      padding: 10px 14px;
      width: 80%;
      height: 20px;
      margin: 0 auto;
      text-align: left;
      font-size: 15px;
      font-weight: 400;
      border: none;
      background-color: rgba(238, 238, 238, 1);
      border-bottom: 1px solid rgba(197, 197, 197, 1);
      border-radius: 4px;
      text-transform: uppercase;
      color: #000;
    }
  }
}
</style>
